module.exports = __webpack_public_path__ + "static/media/report-recycle-selected.ac885ed1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/styles/images/sp/report-recycle-selected.svg
// module id = 391
// module chunks = 0